(function(ns) {
	"use strict";

	var storageName = "user-entry";

	/// 共有データストア
	ns.store = {
		valid_post: "",
		state: {
			loading: false,
			saveError: false,
			completed: false,
		},
		entry: {
			email: null,
			will: [],
		},
		entry_error: {
		},
		resetEntry: function() {
			var entry = ns.store.entry;
			Object.keys(entry).forEach(function(key) {
				delete entry[key];
			});
			entry.email = "";

			var entry_error = ns.store.entry_error;
			Object.keys(entry_error).forEach(function(key) {
				delete entry_error[key];
			});
		},
	};

	/// 入力中のデータを localStorage に保存する
	ns.saveState = function() {
		localStorage.setItem(storageName, JSON.stringify({
			completed: ns.store.state.completed,
			entry: ns.store.entry,
		}));
	};

	/// localStorage に保存されたデータを復元する
	ns.restoreState = function() {
		var json = localStorage.getItem(storageName);
		if (!json) {
			return;
		}
		try {
			var state = JSON.parse(json);
			if (!state.entry) {
				return;
			}
			ns.store.state.completed = !!state.completed;
			ns.store.entry = state.entry;
		} catch (e) {}
	};

	/// データを消去する（申し込み完了時に呼び出し）
	ns.clearState = function() {
		localStorage.removeItem(storageName);
	};

})(UE);
